import event_overview from '@/domain/eventManage/routes/overview'
import event_configuration from '@/domain/eventManage/routes/configuration'
import event_media from '@/domain/eventManage/routes/media'
import event_administration from '@/domain/eventManage/routes/administration'
import event_report from '@/domain/eventManage/routes/report'
import event_collaborators from '@/domain/eventManage/routes/collaborators'
import event_wizard from '@/domain/eventWizard/routes'
import event_gallery from '@/domain/eventGallery/routes'
import EventManager from "@/domain/eventManage/EventManager.vue";
import PicaServiceRedirect from "@/domain/eventManage/PicaServiceRedirect.vue";
import photo_search from "@/domain/photoSearch/routes";
import photo_map from '@/domain/photoMap/routes'
import checkin from '@/domain/checkin/routes'
import edge_orders from '@/domain/edgeOrders/routes'
import edge_prints from '@/domain/edgePrints/routes'

export default [
    {
        path: '/events/:picaServiceId([0-9]+)',
        name: 'eventIndex',
        component: EventManager,
        meta: {
            label: 'Event',
            breadcrumb: (context) => {
                const eventName = context.store.getters['event/currentEventName']
                return {
                    text: eventName || 'Event',
                    to: { name: 'picaServiceRedirect', params: context.route.params }
                }
            }
        },
        children: [
            {
                path: '',
                name: 'picaServiceRedirect',
                component: PicaServiceRedirect,
            },
            ...event_overview,
            ...event_configuration,
            ...event_media,
            ...event_administration,
            ...event_report,
            ...event_collaborators,
            ...event_wizard,
            ...event_gallery,
            ...photo_search,
            ...photo_map,
            ...checkin,
            ...edge_orders,
            ...edge_prints,

        ]
    },
]
